import { keyframes } from "@emotion/react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const loadingAnimation = keyframes`
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
`;

const LoadingComponent = () => (
  <MDBox
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100vh"
  >
    <MDTypography
      variant="h4"
      sx={{
        "&::after": {
          content: "''",
          animation: `${loadingAnimation} 1.5s infinite`,
        },
      }}
    >
      Carregando
    </MDTypography>
  </MDBox>
);

export default LoadingComponent;